import { HttpClient, HttpClientModule } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { NgModule, LOCALE_ID, APP_INITIALIZER } from '@angular/core';
import { of } from 'rxjs';
import { TUI_LANGUAGE } from '@taiga-ui/i18n';
import { TUI_SPANISH_LANGUAGE } from '@taiga-ui/i18n/languages/spanish';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialogModule } from '@angular/material/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AmplifyAuthenticatorModule } from '@aws-amplify/ui-angular';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TuiDataListModule, TuiDialogModule, TuiFlagPipeModule, TuiPrimitiveTextfieldModule, TuiRootModule, TuiTextfieldControllerModule } from '@taiga-ui/core';
import { TuiMultiSelectModule, TuiSortCountriesPipeModule, TuiDataListWrapperModule, TuiInputDateRangeModule, TuiSliderModule, TuiRangeModule, TuiInputDateTimeModule } from '@taiga-ui/kit';
import { NgxPayPalModule } from 'ngx-paypal';
import { AWSLambda } from './AWSLambda.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ButtonModule } from './components/button/button.module';
import { LanguageComponent } from './components/language/language.component';
import { MenuComponent } from './components/menu/menu.component';
import { ProfileComponent } from './components/menu/profile/profile.component';
import { TabsModule } from './components/tabs/tabs.module';
import { ZendyHeaderDesktopComponent } from './components/zendy-header/zendy-header-desktop.component';
import { ZendyHeaderComponent } from './components/zendy-header/zendy-header.component';
import { FilterCountriesPipe } from './components/zendy-intl-phone/filter-countries.pipe';
import { ConfigService } from './config.service';
import { ConditionsComponent } from './features/about/conditions/conditions.component';
import { HelpComponent } from './features/about/help/help.component';
import { BalanceModule } from './features/balances/balance.module';
import { CheckoutNotificationComponent } from './features/checkout-notification/checkout-notification.component';
import { ContactDetailsComponent } from './features/contacts/contact-details/contact-details.component';
import { ContactsListComponent } from './features/contacts/contacts-list.component';
import { ContactsComponent } from './features/contacts/contacts.component';
import { NewContactComponent } from './features/contacts/new-contact/new-contact.component';
import { HeaderComponent } from './features/header/header.component';
import { HistoryListComponent } from './features/history/history-list.component';
import { HistoryComponent } from './features/history/history.component';
import { HomeComponent } from './features/home/home.component';
import { HomeDashboardComponent } from './features/home/dashboard.component';
import { PromosComponent } from './features/home/promos.component';
import { DeleteAccountComponent } from './features/my-profile/delete-account/delete-account.component';
import { EditMyProfileComponent } from './features/my-profile/edit-profile/edit-profile.component';
import { VerifyNumberComponent } from './features/my-profile/verify-number/verify-number.component';
import { MyProfileComponent } from './features/my-profile/my-profile.component';
import { OnBoardingModule } from './features/onboarding/onboarding.module';
import { CountriesModalComponent } from './features/rates/countries-modal.component';
import { RatesModalComponent } from './features/rates/rates-modal.component';
import { RechargesComponent } from './features/recharges/recharges.component';
import { SendMoneyComponent } from './features/send-money/send-money.component';
import { TransfersComponent } from './features/transfers/transfers.component';
import { UtilsModule } from './utils/utils.module';
import { TransfersListComponent } from './features/transfers/transfers-list.component';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import localeEn from '@angular/common/locales/en';
import { TuiAccordionModule, TuiActionModule,TuiSelectModule,TuiToCountryCodePipe } from '@taiga-ui/kit';
import { TuiLetModule } from '@taiga-ui/cdk';
import { ItemDetailDialogComponent } from './components/item-detail-dialog/item-detail-dialog.component';
import { EsimComponent } from './features/esim/esim.component';
import { MyEsimsComponent } from './features/esim/my-esims/my-esims.component';
import { BuyNowModalComponent } from './features/esim/buy-now-modal/buy-now-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatTabsModule } from '@angular/material/tabs';
import { TopupsModalComponent } from './features/esim/topups-modal/topups-modal.component';
import { PurchaseDetailsModalComponent } from './features/esim/purchase-details-modal/purchase-details-modal.component';
/*import { EsimLoginComponent } from './features/esim-login/esim-login.component';*/
import { UserEsimDetailsComponent } from './features/esim/user-esim-details/user-esim-details.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TopupComponent } from './features/esim/topup/topup.component';
import { DetailsComponent } from './features/esim/details/details.component';
import { ZendyIntlPhoneComponent } from "src/app/components/zendy-intl-phone/zendy-intl-phone.component";
import { SpinnerComponent } from './components/spinner/spinner.component';
import { PromoComponent } from './components/promo/promo.component';
import { SpinnerModule } from './components/spinner/spinner.module';
import { BeneficiaryFormComponent } from './components/forms/beneficiary.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatStepperModule } from '@angular/material/stepper';

import { IgxCarouselModule } from 'igniteui-angular';

import { GlobalDataService } from './services/global-data.service';
import { AppInitService } from './app-init.factory';
import { SharedPipesModule } from './utils/shared-pipes.module';
import { NewCostumerComponent } from './features/ISP/newCostumer.component';

// BTB Components
import { BtbPartnerInfoComponent } from './components/btb/btb-partner-info.component';
import { BtbTabsComponent } from './components/btb/btb-tabs.component';
import { BtbInvoicesListComponent } from './components/btb/btb-invoices-list.component';
import { BtbTransactionsListComponent } from './components/btb/btb-transactions-list.component';
import { BtbCommissionListComponent } from './components/btb/btb-commission-list.component';
import { GenericListComponent } from './components/generic-list/generic-list.component';
import { ConditionsFormComponent } from './features/backoffice/PromoyCondiciones/conditions-form.component';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

// backoffice
import { BODashboardComponent } from './features/backoffice/BODashboard.component';
import { BOUsersComponent } from './features/backoffice/users/users.component';
import { BOUserProfileComponent } from './features/backoffice/users/user-profile.component';
import { BOEditUserComponent } from './features/backoffice/users/edit-user.component';
import { BOEsimListComponent } from './features/backoffice/users/esimList.component';
import { BOEsimDetailsModalComponent } from './features/backoffice/users/esim-details-modal.component';
import { BOPartnersComponent } from './features/backoffice/partners/partners.component';
import { PartnerDetailComponent } from './features/backoffice/partners/partner-detail.component';
import { AddInvoiceDialogComponent as BtbAddInvoiceDialogComponent } from './features/btb/add-invoice-dialog.component';
import { TransaccionesComponent } from './features/backoffice/Transactions/Transacciones.component';
import { BOPricingListComponent } from './features/backoffice/calls-pricing/calls-pricing-list.component';
import { BOEditCallPriceComponent } from './features/backoffice/calls-pricing/edit-call-price.component';
import { TransaccionDetailComponent } from './features/backoffice/Transactions/transactionDetail.component';
import { BOErrorLogComponent } from './features/backoffice/error-log/error-log.component';
import { Configcomponent } from './features/backoffice/Config/Config.component';
import { EditConfigComponent } from './features/backoffice/Config/edit-config.component';
import { BOHoldedToSageComponent } from './features/backoffice/document-processing/holded-to-sage/holded-to-sage.component';
import { BOHoldedToSageComponent2025 } from './features/backoffice/document-processing/holded-to-sage-2025/holded-to-sage.component';
import { ConversionErrorDialogComponent } from './features/backoffice/document-processing/holded-to-sage/conversion-error-dialog.component';
import { ConversionErrorDialogComponent2025 } from './features/backoffice/document-processing/holded-to-sage-2025/conversion-error-dialog.component';
import { DocumentProcessingComponent } from './features/backoffice/document-processing/herramientas.component';
import { CdrProcessingComponent } from './features/backoffice/document-processing/cdr-processing/cdr-processing.component';
import { TxUsuariosComponent} from './features/backoffice/Transactions/TxUsuarios.component';
import { AddBalanceComponent} from './features/backoffice/users/AddBalance.Component';
import { BOEsimGiftComponent } from './features/backoffice/users/bo-esim-gift/bo-esim-gift.component';
import { BOEsimGiftDetailsComponent } from './features/backoffice/users/bo-esim-gift-details/bo-esim-gift-details.component';
import { EsimCatalogComponent } from './features/backoffice/esim-catalog/esim-catalog.component';
import { DocumentStoreComponent } from './features/backoffice/document-store/document-store.component';
import { CdrBillingComponent } from './features/backoffice/cdr-billing/cdr-billing.component';

//btb
import { btbDashboardComponent } from './features/btb/Dashboard.component';
import { DeleteAccountComponent as DeleteAccountComponentBTB } from './features/btb/my-profile/delete-account/delete-account.component';
import { EditMyProfileComponent as EditMyProfileComponentBTB } from './features/btb/my-profile/edit-profile/edit-profile.component';
import { VerifyNumberComponent as VerifyNumberComponentBTB } from './features/btb/my-profile/verify-number/verify-number.component';
import { MyProfileComponent as MyProfileComponentBTB } from './features/btb/my-profile/my-profile.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmDialogComponent } from './components/modals/confirm-dialog.component';
import { EditItemsComponent } from './features/backoffice/PromoyCondiciones/edit-items.component';

registerLocaleData(localeEs, 'es');
registerLocaleData(localeEn, 'en');

@NgModule({
  declarations: [
    AppComponent,
    ContactsComponent,
    ContactsListComponent,
    HeaderComponent,
    TransfersComponent,
    RechargesComponent,
    HistoryComponent,
    HistoryListComponent,
    HomeComponent,
    HomeDashboardComponent,
    PromosComponent,
    SendMoneyComponent,
    CheckoutNotificationComponent,
    ZendyHeaderComponent,
    ZendyHeaderDesktopComponent,
    NewContactComponent,
    MyProfileComponent,
    EditMyProfileComponent,
    EditItemsComponent,
    DeleteAccountComponent,
    VerifyNumberComponent,
    ContactDetailsComponent,
    CountriesModalComponent,
    RatesModalComponent,
    ConditionsComponent,
    HelpComponent,
    TransfersListComponent,
    ItemDetailDialogComponent,
    EsimComponent,
    MyEsimsComponent,
    BuyNowModalComponent,
    TopupsModalComponent,
    PurchaseDetailsModalComponent,
/*    EsimLoginComponent,*/
    UserEsimDetailsComponent,
    TopupComponent,
    DetailsComponent,
    SpinnerComponent,
    PromoComponent,
    GenericListComponent,
    ConditionsFormComponent,
    BeneficiaryFormComponent,
    NewCostumerComponent,
    /*    Backoffice,*/
    BODashboardComponent,
    BOUsersComponent,
    BOUserProfileComponent,
    BOEditUserComponent,
    BOEsimListComponent,
    BOEsimDetailsModalComponent,
    BOPartnersComponent,
    PartnerDetailComponent,
    TransaccionesComponent,
    BOPricingListComponent,
    BOEditCallPriceComponent,
    TransaccionDetailComponent,
    BOErrorLogComponent,
    Configcomponent,
    EditConfigComponent,
    BOHoldedToSageComponent,
    BOHoldedToSageComponent2025,
    ConversionErrorDialogComponent2025,
    ConversionErrorDialogComponent,
    DocumentProcessingComponent,
    CdrProcessingComponent,
    TxUsuariosComponent,
    AddBalanceComponent,
    BOEsimGiftComponent,
    BOEsimGiftDetailsComponent,
    EsimCatalogComponent,
    DocumentStoreComponent,
    CdrBillingComponent,
    /*    BTB  */
    btbDashboardComponent,
    MyProfileComponentBTB,
    EditMyProfileComponentBTB,
    DeleteAccountComponentBTB,
    VerifyNumberComponentBTB,
    ConfirmDialogComponent,
    // BTB Components
    BtbPartnerInfoComponent,
    BtbTabsComponent,
    BtbInvoicesListComponent,
    BtbTransactionsListComponent,
    BtbCommissionListComponent,
    BtbAddInvoiceDialogComponent
  ],
  imports: [
    SharedPipesModule,
    MatAutocompleteModule,
    MatStepperModule,
    TuiMultiSelectModule,
    TuiDataListWrapperModule,
    TuiInputDateRangeModule,
    TuiSliderModule,
    TuiRangeModule,
    TuiDataListModule,
    TuiSelectModule,
    FormsModule,
    ReactiveFormsModule,
    TuiInputDateTimeModule,
    TuiDialogModule,
    TuiTextfieldControllerModule,
    TuiLetModule,
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AmplifyAuthenticatorModule,
    UtilsModule,
    NgxPayPalModule,
    MatTableModule,
    MatButtonModule,
    MatRadioModule,
    MatCheckboxModule,
    MatInputModule,
    MatSnackBarModule,
    MatTooltipModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatChipsModule,
    MatGridListModule,
    MatMenuModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    TabsModule,
    ButtonModule,
    SpinnerModule,
    MatSidenavModule,
    BalanceModule,
    OnBoardingModule,
    TranslateModule.forRoot({
      defaultLanguage: 'es',
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    MatCardModule,
    TuiRootModule,
    ProfileComponent,
    MenuComponent,
    MatDialogModule,
    MatProgressSpinnerModule,
    TuiFlagPipeModule,
    MatSelectModule,
    LanguageComponent,
    TuiPrimitiveTextfieldModule,
    TuiTextfieldControllerModule,
    FilterCountriesPipe,
    TuiSortCountriesPipeModule,
    TuiAccordionModule,
    TuiActionModule,
    NgSelectModule,
    MatTabsModule,
    MatExpansionModule,
    MatProgressBarModule,
    ZendyIntlPhoneComponent,
    IgxCarouselModule,
    ClipboardModule
  ],
  providers: [
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { subscriptSizing: 'dynamic' } },
    { provide: LOCALE_ID, useValue: 'es-ES' },
    { provide: TUI_LANGUAGE, useValue: of(TUI_SPANISH_LANGUAGE) },
    DatePipe,
    ConfigService,
    AWSLambda,
    GlobalDataService,
    AppInitService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppInitService],
      multi: true
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }

export function initializeApp(appInitService: AppInitService) {
  return () => appInitService.init();
}
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
